import { authRoles } from 'app/auth';
import VizsgaFeladatsorEditForm from './editform/VizsgaFeladatsorEditForm';
import VizsgaFeladatsorTable from './table/VizsgaFeladatsorTable';

export default [
	{
		path: '/vizsga-feladatsor/edit/:id/:vizsgaVizsgasor?',
		component: VizsgaFeladatsorEditForm,
		auth: authRoles.admin
	},
	{
		path: '/vizsga-feladatsor/:sessionNameParam?',
		component: VizsgaFeladatsorTable,
		auth: authRoles.admin
	}
];
